import { MAT_DIALOG_DATA, MatDialogRef} from '@angular/material/dialog';
import { Component, Inject } from "@angular/core";
import { OrdersService } from "@app/core/services/orders.service";
import { saveAs } from 'file-saver-es';
import { ReportIdentifier, ReportType } from "./model/reportIdentifier";

@Component({
    templateUrl:'./export.report.modal.html',
    styleUrls:['./export.report.modal.scss']
})

export class ExportReportModal{

    public reportType:string = "";


    constructor( public dialogRef: MatDialogRef<ExportReportModal>,
                 private orderService:OrdersService,
                 @Inject(MAT_DIALOG_DATA) private orderId:string){

    }

    exportToExcel(){
		if(!this.orderId){
			return;
		}
        const report:ReportType  = ReportIdentifier.getReportByType(this.reportType);
        if(report){
			// this.orderService.exportToXls(this.orderId as string,report.reportType).subscribe(res=>{
			//     this.dialogRef.close()
			// 	saveAs(res, report.reportName);
			// })
    	}
	}
}
